import { Pencil, Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const BlogTable = ({ posts, onEdit, onDelete }) => (
  <div className="border border-olive/30 bg-cream">
    <Table>
      <TableHeader>
        <TableRow className="border-olive/30 hover:bg-transparent">
          <TableHead className="text-charcoal/70">Title</TableHead>
          <TableHead className="text-charcoal/70">Category</TableHead>
          <TableHead className="text-charcoal/70">Status</TableHead>
          <TableHead className="text-charcoal/70 text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {posts.map((b) => (
          <TableRow key={b.id} data-testid={`admin-blog-row-${b.id}`} className="border-olive/20">
            <TableCell>
              <div className="flex items-center gap-3">
                <img src={b.image_url} alt="" className="w-14 h-12 object-cover" />
                <span className="font-body text-charcoal max-w-xs truncate">{b.title}</span>
              </div>
            </TableCell>
            <TableCell className="font-body text-charcoal/70">{b.category}</TableCell>
            <TableCell className="font-body text-charcoal/70">{b.published ? "Published" : "Draft"}</TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-2">
                <button data-testid={`edit-blog-${b.id}`} onClick={() => onEdit(b)} className="p-2 text-charcoal/60 hover:text-burgundy transition-colors">
                  <Pencil size={16} />
                </button>
                <button data-testid={`delete-blog-${b.id}`} onClick={() => onDelete(b)} className="p-2 text-charcoal/60 hover:text-maroon transition-colors">
                  <Trash2 size={16} />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
